import { useAuth } from "hooks";
import React, { useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import api from "services/api";
import { resetProfileSlice, setProfileSlice } from "../../redux/slices/profile_slice";

export const Header = () => {
  const { token, removeToken, user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const isLoggedIn = localStorage.getItem("user");
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.profile.profileDataRedux);
  console.log("userData:", userData);
  const handleLogout = () => {
    api
      .post("/logout", {})
      .then((res) => {
        removeToken();
        dispatch(resetProfileSlice()) // logout cheseka previous employee details remove chesesa
        navigate("/");
      })
      .catch((err) => {});
  };
  const handlePlansClick = (e) => {
    navigate("/plans");
  };

  const handleContactUsClick = (e) => {
    navigate("/");
    setTimeout(() => {
      const contactUsSection = document.getElementById("contactUs");
      if (contactUsSection) {
        contactUsSection.scrollIntoView({ behavior: "smooth" });
      }
    }, 100);
  };

  const fetchUserDetails = async () => {
    try {
      const response = await api.get(`/users/${user?.user_id}`);
      const data = response?.data?.data?.user;
      dispatch(setProfileSlice(data));
      console.log("header:", data);
    } catch (error) {
      console.log("error response:", error);
    }
  };
  useEffect(() => {
    if (!userData) {
      fetchUserDetails();
    } else if (token) {
      fetchUserDetails()
    }
  }, [token]);

  return (
    <>
      <nav
        className="layout-navbar shadow-none py-0"
        style={{ position: "sticky", top: "0px" }}
      >
        <div className="mx-2">
          <div
            className="navbar navbar-expand-lg landing-navbar px-3 px-md-4"
            style={{ backgroundColor: "#fff" }}
          >
            <div className="navbar-brand app-brand demo d-flex py-0 py-lg-2 me-4">
              <button
                className="navbar-toggler border-0 px-0 me-2"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <i className="ti ti-menu-2 ti-sm align-middle" />
              </button>

              <Link to="/" className="app-brand-link">
                <span className="app-brand-logo demo">
                  <img
                    src="../../assets/img/flowersvg.svg"
                    style={{
                      width: "40px",
                      height: "26px",
                      borderRadius: "50%",
                    }}
                  />
                </span>
                <span class="app-brand-text demo menu-text fw-bold">
                  Zenosure
                </span>
              </Link>
            </div>
            <div
              className="collapse navbar-collapse landing-nav-menu"
              id="navbarSupportedContent"
            >
              <button
                className="navbar-toggler border-0 text-heading position-absolute end-0 top-0 scaleX-n1-rtl"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <i className="ti ti-x ti-sm" />
              </button>
              <ul className="navbar-nav me-auto ">
                <li
                  className={`nav-item me-3 ${
                    location.pathname === "/" ? "active" : ""
                  }`}
                >
                  <Link
                    className="nav-link fw-medium"
                    aria-current="page"
                    to="/"
                  >
                    Home
                  </Link>
                </li>
                <li
                  className={`nav-item me-3 ${
                    location.pathname === "/plans" ? "active" : ""
                  }`}
                >
                  <button
                    onClick={handlePlansClick}
                    className="nav-link fw-medium"
                  >
                    Plans
                  </button>
                </li>
                <li
                  className={`nav-item ${
                    location.pathname === "/partners" ? "active" : ""
                  }`}
                >
                  <Link className="nav-link fw-medium" to="/partners">
                    Our Partners
                  </Link>
                </li>
              </ul>
            </div>
            <div className="landing-menu-overlay d-lg-none" />
            <ul className="navbar-nav flex-row align-items-center ms-auto">
              <li className="nav-item dropdown-style-switcher dropdown me-2 me-xl-0">
                <a
                  className="nav-link dropdown-toggle hide-arrow"
                  href="javascript:void(0);"
                  data-bs-toggle="dropdown"
                >
                  <i className="ti ti-sm" />
                </a>
                <ul className="dropdown-menu dropdown-menu-end dropdown-styles">
                  <li>
                    <a
                      className="dropdown-item"
                      href="javascript:void(0);"
                      data-theme="light"
                    >
                      <span className="align-middle">
                        <i className="ti ti-sun me-2" />
                        Light
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      className="dropdown-item"
                      href="javascript:void(0);"
                      data-theme="dark"
                    >
                      <span className="align-middle">
                        <i className="ti ti-moon me-2" />
                        Dark
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      className="dropdown-item"
                      href="javascript:void(0);"
                      data-theme="system"
                    >
                      <span className="align-middle">
                        <i className="ti ti-device-desktop me-2" />
                        System
                      </span>
                    </a>
                  </li>
                </ul>
              </li>
              <li>
                <span className="">
                  {token ? (
                    <li className="nav-item navbar-dropdown dropdown-user ">
                      <Link
                        className="nav-link dropdown-toggle hide-arrow"
                        to="javascript:void(0);"
                        data-bs-toggle="dropdown"
                      >
                        <div className="avatar avatar-online">
                          <img
                            src={
                              userData?.profile?.profile_pic_url ||
                              "../../assets/img/avatars/14.jpg"
                            }
                            alt
                            style={{
                              borderRadius: "50%",
                              width: "40px" /* Set the width */,
                              height: "40px" /* Set the height */,
                              objectFit:
                                "cover" /* Ensure the image scales properly */,
                              borderRadius: "50%" /* Make it  circular */,
                            }}
                          />
                        </div>
                      </Link>
                      <ul className="dropdown-menu dropdown-menu-end">
                        <li>
                          <Link className="dropdown-item">
                            <div className="d-flex">
                              <div className="flex-shrink-0 me-3">
                                <div className="avatar avatar-online">
                                  <img
                                    src={userData?.profile?.profile_pic_url}
                                    alt
                                    // className="h-auto rounded-circle"
                                    style={{
                                      borderRadius: "50%",
                                    }}
                                  />
                                </div>
                              </div>
                              <div className="flex-grow-1">
                                <small className="text-muted">
                                  {userData?.first_name}
                                </small>
                              </div>
                            </div>
                          </Link>
                        </li>
                        <li>
                          <div className="dropdown-divider"></div>
                        </li>
                        <li>
                          <Link className="dropdown-item" to="/profile">
                            <i className="ti ti-user-check me-2 ti-sm"></i>
                            <span className="align-middle">My Profile</span>
                          </Link>
                        </li>
                        <li>
                          <Link className="dropdown-item" to="/dashboard">
                            <i className="ti ti-settings me-2 ti-sm"></i>
                            <span className="align-middle">Dashboard </span>
                          </Link>
                        </li>
                        <li>
                          <div className="dropdown-divider"></div>
                        </li>
                        <li>
                          <Link
                            className="dropdown-item"
                            onClick={handleLogout}
                          >
                            <i className="ti ti-chevrons-right me-2 ti-sm"></i>
                            <span className="align-middle">Logout</span>
                          </Link>
                        </li>
                      </ul>
                    </li>
                  ) : (
                    <Link to="/login" className="btn btn-primary">
                      Sign In
                    </Link>
                  )}
                </span>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
};
